{
  "name": "urx-router",
  "version": "1.18.5",
  "description": "Routing planner for YAMAHA URX22 / URX44 / URX44V USB audio interfaces",
  "license": "MIT",
  "private": true,
  "type": "module",
  "packageManager": "pnpm@10.7.1",
  "engines": {
    "node": "^22.22.2 || ^24.15.0 || >=26.0.0"
  },
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && vite build",
    "build:demo": "tsc --noEmit && vite build --mode demo",
    "build:trace": "tsc --noEmit && vite build --mode trace --outDir dist-trace",
    "typecheck:e2e": "tsc -p tsconfig.e2e.json",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:e2e": "playwright test",
    "test:e2e:app": "playwright test --project=chromium",
    "test:e2e:app:webkit": "playwright test --project=app-webkit",
    "test:e2e:coverage": "cross-env E2E_COVERAGE=1 playwright test --project=chromium",
    "test:e2e:race": "playwright test --project=race",
    "test:e2e:race:webkit": "playwright test --project=race-webkit",
    "check:md": "node scripts/check-md-tables.mjs",
    "check:assets": "node scripts/check-assets-index.mjs",
    "check:comments": "node scripts/check-comment-provenance.mjs",
    "check:pr-assumptions": "node scripts/check-pr-assumptions.mjs",
    "check:gates": "node scripts/check-merge-gates.mjs",
    "check:skips": "node scripts/check-race-skips.mjs",
    "check:platform": "node scripts/check-macho-platform.mjs",
    "verify:release-draft": "node scripts/verify-release-draft.mjs",
    "format": "node scripts/format.mjs",
    "preview": "vite preview --port 4173 --strictPort",
    "e2e:serve": "node scripts/e2e-serve.mjs",
    "e2e:serve:trace": "node scripts/e2e-serve.mjs --trace",
    "e2e:worktree": "node scripts/e2e-worktree.mjs",
    "sync:merged": "node scripts/sync-merged.mjs",
    "reset:storage": "node scripts/reset-storage.mjs",
    "tauri": "tauri",
    "clean": "rm -rf node_modules/.vite dist dist-trace && cargo clean --manifest-path src-tauri/Cargo.toml",
    "bench:meters": "node scripts/meter-bench-run.mjs"
  },
  "devDependencies": {
    "@playwright/test": "^1.64.1",
    "@tauri-apps/cli": "^2.12.4",
    "@types/node": "24",
    "@vitest/coverage-v8": "^5.0.5",
    "cross-env": "^10.1.0",
    "esbuild": "^0.28.2",
    "jsdom": "^30.1.3",
    "monocart-coverage-reports": "^3.2.0",
    "prettier": "^3.9.10",
    "typescript": "^7.0.2",
    "vite": "^8.3.5",
    "vitest": "^5.0.5"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "esbuild"
    ]
  },
  "prettier": {
    "printWidth": 120
  },
  "dependencies": {
    "urx-lcd-sim": "link:vendor/urx-lcd-sim"
  }
}
